import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

// TODO fix AoT Compiler Error (https://github.com/angular/angular/issues/11262)


@NgModule({
    imports: [
        // Angular stuff
        CommonModule,
    ],
    exports: [
        // Angular stuff.
        CommonModule,
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        RouterModule,
        MatTooltipModule,
    ],
})
export class SharedModule
{
}
